/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as CountryLanguageRouteRouteImport } from './routes/$country.$language/route'
import { Route as CountryLanguageBryggaRouteImport } from './routes/$country.$language/brygga'
import { Route as CountryLanguageSplatRouteImport } from './routes/$country.$language/$'
import { Route as CountryLanguagePlannerIndexRouteImport } from './routes/$country.$language/planner/index'
import { Route as CountryLanguageNavigatorIndexRouteImport } from './routes/$country.$language/navigator/index'
import { Route as CountryLanguagePlannerRangeIdRouteImport } from './routes/$country.$language/planner/$rangeId'
import { Route as CountryLanguageNavigatorSplatRouteImport } from './routes/$country.$language/navigator/$'
import { Route as CountryLanguageNavigatorDesignCodeRouteImport } from './routes/$country.$language/navigator/design/$code'
import { Route as CountryLanguageNavigatorRangeIdIdRouteImport } from './routes/$country.$language/navigator/$rangeId.$id'

const CountryLanguageRouteRoute = CountryLanguageRouteRouteImport.update({
  id: '/$country/$language',
  path: '/$country/$language',
  getParentRoute: () => rootRouteImport,
} as any)
const CountryLanguageBryggaRoute = CountryLanguageBryggaRouteImport.update({
  id: '/brygga',
  path: '/brygga',
  getParentRoute: () => CountryLanguageRouteRoute,
} as any)
const CountryLanguageSplatRoute = CountryLanguageSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => CountryLanguageRouteRoute,
} as any)
const CountryLanguagePlannerIndexRoute =
  CountryLanguagePlannerIndexRouteImport.update({
    id: '/planner/',
    path: '/planner/',
    getParentRoute: () => CountryLanguageRouteRoute,
  } as any)
const CountryLanguageNavigatorIndexRoute =
  CountryLanguageNavigatorIndexRouteImport.update({
    id: '/navigator/',
    path: '/navigator/',
    getParentRoute: () => CountryLanguageRouteRoute,
  } as any)
const CountryLanguagePlannerRangeIdRoute =
  CountryLanguagePlannerRangeIdRouteImport.update({
    id: '/planner/$rangeId',
    path: '/planner/$rangeId',
    getParentRoute: () => CountryLanguageRouteRoute,
  } as any)
const CountryLanguageNavigatorSplatRoute =
  CountryLanguageNavigatorSplatRouteImport.update({
    id: '/navigator/$',
    path: '/navigator/$',
    getParentRoute: () => CountryLanguageRouteRoute,
  } as any)
const CountryLanguageNavigatorDesignCodeRoute =
  CountryLanguageNavigatorDesignCodeRouteImport.update({
    id: '/navigator/design/$code',
    path: '/navigator/design/$code',
    getParentRoute: () => CountryLanguageRouteRoute,
  } as any)
const CountryLanguageNavigatorRangeIdIdRoute =
  CountryLanguageNavigatorRangeIdIdRouteImport.update({
    id: '/navigator/$rangeId/$id',
    path: '/navigator/$rangeId/$id',
    getParentRoute: () => CountryLanguageRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/$country/$language': typeof CountryLanguageRouteRouteWithChildren
  '/$country/$language/$': typeof CountryLanguageSplatRoute
  '/$country/$language/brygga': typeof CountryLanguageBryggaRoute
  '/$country/$language/navigator/$': typeof CountryLanguageNavigatorSplatRoute
  '/$country/$language/planner/$rangeId': typeof CountryLanguagePlannerRangeIdRoute
  '/$country/$language/navigator/': typeof CountryLanguageNavigatorIndexRoute
  '/$country/$language/planner/': typeof CountryLanguagePlannerIndexRoute
  '/$country/$language/navigator/$rangeId/$id': typeof CountryLanguageNavigatorRangeIdIdRoute
  '/$country/$language/navigator/design/$code': typeof CountryLanguageNavigatorDesignCodeRoute
}
export interface FileRoutesByTo {
  '/$country/$language': typeof CountryLanguageRouteRouteWithChildren
  '/$country/$language/$': typeof CountryLanguageSplatRoute
  '/$country/$language/brygga': typeof CountryLanguageBryggaRoute
  '/$country/$language/navigator/$': typeof CountryLanguageNavigatorSplatRoute
  '/$country/$language/planner/$rangeId': typeof CountryLanguagePlannerRangeIdRoute
  '/$country/$language/navigator': typeof CountryLanguageNavigatorIndexRoute
  '/$country/$language/planner': typeof CountryLanguagePlannerIndexRoute
  '/$country/$language/navigator/$rangeId/$id': typeof CountryLanguageNavigatorRangeIdIdRoute
  '/$country/$language/navigator/design/$code': typeof CountryLanguageNavigatorDesignCodeRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/$country/$language': typeof CountryLanguageRouteRouteWithChildren
  '/$country/$language/$': typeof CountryLanguageSplatRoute
  '/$country/$language/brygga': typeof CountryLanguageBryggaRoute
  '/$country/$language/navigator/$': typeof CountryLanguageNavigatorSplatRoute
  '/$country/$language/planner/$rangeId': typeof CountryLanguagePlannerRangeIdRoute
  '/$country/$language/navigator/': typeof CountryLanguageNavigatorIndexRoute
  '/$country/$language/planner/': typeof CountryLanguagePlannerIndexRoute
  '/$country/$language/navigator/$rangeId/$id': typeof CountryLanguageNavigatorRangeIdIdRoute
  '/$country/$language/navigator/design/$code': typeof CountryLanguageNavigatorDesignCodeRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/$country/$language'
    | '/$country/$language/$'
    | '/$country/$language/brygga'
    | '/$country/$language/navigator/$'
    | '/$country/$language/planner/$rangeId'
    | '/$country/$language/navigator/'
    | '/$country/$language/planner/'
    | '/$country/$language/navigator/$rangeId/$id'
    | '/$country/$language/navigator/design/$code'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/$country/$language'
    | '/$country/$language/$'
    | '/$country/$language/brygga'
    | '/$country/$language/navigator/$'
    | '/$country/$language/planner/$rangeId'
    | '/$country/$language/navigator'
    | '/$country/$language/planner'
    | '/$country/$language/navigator/$rangeId/$id'
    | '/$country/$language/navigator/design/$code'
  id:
    | '__root__'
    | '/$country/$language'
    | '/$country/$language/$'
    | '/$country/$language/brygga'
    | '/$country/$language/navigator/$'
    | '/$country/$language/planner/$rangeId'
    | '/$country/$language/navigator/'
    | '/$country/$language/planner/'
    | '/$country/$language/navigator/$rangeId/$id'
    | '/$country/$language/navigator/design/$code'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  CountryLanguageRouteRoute: typeof CountryLanguageRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/$country/$language': {
      id: '/$country/$language'
      path: '/$country/$language'
      fullPath: '/$country/$language'
      preLoaderRoute: typeof CountryLanguageRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$country/$language/brygga': {
      id: '/$country/$language/brygga'
      path: '/brygga'
      fullPath: '/$country/$language/brygga'
      preLoaderRoute: typeof CountryLanguageBryggaRouteImport
      parentRoute: typeof CountryLanguageRouteRoute
    }
    '/$country/$language/$': {
      id: '/$country/$language/$'
      path: '/$'
      fullPath: '/$country/$language/$'
      preLoaderRoute: typeof CountryLanguageSplatRouteImport
      parentRoute: typeof CountryLanguageRouteRoute
    }
    '/$country/$language/planner/': {
      id: '/$country/$language/planner/'
      path: '/planner'
      fullPath: '/$country/$language/planner/'
      preLoaderRoute: typeof CountryLanguagePlannerIndexRouteImport
      parentRoute: typeof CountryLanguageRouteRoute
    }
    '/$country/$language/navigator/': {
      id: '/$country/$language/navigator/'
      path: '/navigator'
      fullPath: '/$country/$language/navigator/'
      preLoaderRoute: typeof CountryLanguageNavigatorIndexRouteImport
      parentRoute: typeof CountryLanguageRouteRoute
    }
    '/$country/$language/planner/$rangeId': {
      id: '/$country/$language/planner/$rangeId'
      path: '/planner/$rangeId'
      fullPath: '/$country/$language/planner/$rangeId'
      preLoaderRoute: typeof CountryLanguagePlannerRangeIdRouteImport
      parentRoute: typeof CountryLanguageRouteRoute
    }
    '/$country/$language/navigator/$': {
      id: '/$country/$language/navigator/$'
      path: '/navigator/$'
      fullPath: '/$country/$language/navigator/$'
      preLoaderRoute: typeof CountryLanguageNavigatorSplatRouteImport
      parentRoute: typeof CountryLanguageRouteRoute
    }
    '/$country/$language/navigator/design/$code': {
      id: '/$country/$language/navigator/design/$code'
      path: '/navigator/design/$code'
      fullPath: '/$country/$language/navigator/design/$code'
      preLoaderRoute: typeof CountryLanguageNavigatorDesignCodeRouteImport
      parentRoute: typeof CountryLanguageRouteRoute
    }
    '/$country/$language/navigator/$rangeId/$id': {
      id: '/$country/$language/navigator/$rangeId/$id'
      path: '/navigator/$rangeId/$id'
      fullPath: '/$country/$language/navigator/$rangeId/$id'
      preLoaderRoute: typeof CountryLanguageNavigatorRangeIdIdRouteImport
      parentRoute: typeof CountryLanguageRouteRoute
    }
  }
}

interface CountryLanguageRouteRouteChildren {
  CountryLanguageSplatRoute: typeof CountryLanguageSplatRoute
  CountryLanguageBryggaRoute: typeof CountryLanguageBryggaRoute
  CountryLanguageNavigatorSplatRoute: typeof CountryLanguageNavigatorSplatRoute
  CountryLanguagePlannerRangeIdRoute: typeof CountryLanguagePlannerRangeIdRoute
  CountryLanguageNavigatorIndexRoute: typeof CountryLanguageNavigatorIndexRoute
  CountryLanguagePlannerIndexRoute: typeof CountryLanguagePlannerIndexRoute
  CountryLanguageNavigatorRangeIdIdRoute: typeof CountryLanguageNavigatorRangeIdIdRoute
  CountryLanguageNavigatorDesignCodeRoute: typeof CountryLanguageNavigatorDesignCodeRoute
}

const CountryLanguageRouteRouteChildren: CountryLanguageRouteRouteChildren = {
  CountryLanguageSplatRoute: CountryLanguageSplatRoute,
  CountryLanguageBryggaRoute: CountryLanguageBryggaRoute,
  CountryLanguageNavigatorSplatRoute: CountryLanguageNavigatorSplatRoute,
  CountryLanguagePlannerRangeIdRoute: CountryLanguagePlannerRangeIdRoute,
  CountryLanguageNavigatorIndexRoute: CountryLanguageNavigatorIndexRoute,
  CountryLanguagePlannerIndexRoute: CountryLanguagePlannerIndexRoute,
  CountryLanguageNavigatorRangeIdIdRoute:
    CountryLanguageNavigatorRangeIdIdRoute,
  CountryLanguageNavigatorDesignCodeRoute:
    CountryLanguageNavigatorDesignCodeRoute,
}

const CountryLanguageRouteRouteWithChildren =
  CountryLanguageRouteRoute._addFileChildren(CountryLanguageRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  CountryLanguageRouteRoute: CountryLanguageRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
